exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-left {\n  padding: 20px;\n  border-right: 1px solid #f1f1f1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c3e5852c","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"javascriptEnabled":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/FormDetailLeft/index.vue
// module id = vXtm
// module chunks = 142